import moment, { Moment } from 'moment';

/** Geboortedatum in het formaat dat calculate-from-birth verwacht: dd-MM-yyyy. */
export function formatBirthDate(date: Moment): string {
  return date.format('DD-MM-YYYY');
}

/**
 * Bouwt een ISO-8601-Z string uit een kalenderdatum + een reeds-UTC wandklok-tijd
 * ("HH:mm"). De Y-M-D en H:m worden letterlijk als UTC geïnterpreteerd, zodat de
 * timezone van de testmachine/gebruiker het moment niet verschuift.
 */
export function toIsoUtc(date: Moment, timeHHmm: string): string {
  const [hours, minutes] = timeHHmm.split(':').map(part => Number(part));
  return moment
    .utc({ year: date.year(), month: date.month(), date: date.date(), hour: hours, minute: minutes, second: 0 })
    .format('YYYY-MM-DDTHH:mm:ss[Z]');
}
